import styled from '@emotion/styled';

import { Link as NextLink } from '../Link';

const Container = styled.div(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  flexWrap: 'wrap',
  rowGap: theme.eclipseTier1.spacing['4px'],
}));

const Breadcrumb = styled.span({
  overflowWrap: 'anywhere',
  '&:not(:last-child)::after': {
    content: '"/"',
    marginLeft: '0.5em',
    marginRight: '0.5em',
  },
  ':last-child': {
    textDecoration: 'underline',
  },
});

const Link = styled(NextLink)(({ theme }) => ({
  color: theme.stellenportal?.fontStyle?.color || theme.eclipseTier2Color.text.brand.default,
}));

export const S = {
  Container,
  Breadcrumb,
  Link,
} as const;
